<section class="Auto_Popup add-aberration-wrapper">
  <section class="override-item-as-row content">
    <div select-button>
      <div *ngIf="selectedFormName != 'FUSION'" class="radio-buttons-container">
        <dls-radio-button *ngFor="let option of payload.options" name="aberrationType" [(ngModel)]="selectedFormName"
                          value="{{option.code}}" (click)="typeClick(option.code)">{{option.display}}</dls-radio-button>
      </div>
    </div>
    <gen-dynamic-form
      [formName]="selectedFormName"
      [formVertical]="true"
      (submitEmitter)="submit($event)"
      [submitted]="submitted"
      [popupMode]="true"
      (formChange)="form = $event.form"
      (validateChange)="updateValidate($event)"
    ></gen-dynamic-form>
  </section>
</section>
